import React from 'react';
import { connect } from "react-redux";
import { useForm } from 'react-hook-form';
import cleanDeep from "clean-deep";
import PayScheduleRow from './PayScheduleRow';
import { PlusIcon } from '@heroicons/react/20/solid';

const PaySchedules = ({
    existingCompanyDetails,
    updateCompanyDetails,
    addPaySchedule,
    prevPage,
    disabled,
    org
}) => {

    const { paySchedules } = existingCompanyDetails;

    const { handleSubmit } = useForm();

    const onSubmit = () => {
        updateCompanyDetails(cleanDeep({ org: org, paySchedules }, { emptyStrings: false, emptyArrays: false, emptyObjects: false }));
    };

    return (
        <div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-section col-xs-12">
                    <div className="col-xs-12 form-container">
                        <div className='pull-left'>
                            <h4>Pay Schedules</h4>
                        </div>
                        {!disabled &&
                            <button
                                className="btn btn-success pull-right"
                                type="button"
                                onClick={() => {
                                    addPaySchedule()
                                }}
                            >
                                <PlusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                                <div style={{ float: "left" }}>Add Pay Schedule</div>
                            </button>
                        }
                    </div>
                    <div className="col-xs-12 form-container">
                        {paySchedules?.map((payschedule) => {
                            return (<PayScheduleRow key={payschedule.id} paySchedule={payschedule} inModal={true} />)
                        })}
                    </div>
                </div>
                <div style={{ marginTop: 10 }}>
                    <button type="button" className="btn btn-default" onClick={prevPage}>Back</button>
                    <button className="btn btn-success right" type="submit">
                        Save
                    </button>
                </div>
                <div className="clearfix" />
            </form>
        </div>
    )
};

const mapStateToProps = (state) => {
    return {
        existingCompanyDetails: state.company.newCompany,
        org: state.company.newCompany.org,
    }
};

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(PaySchedules);